import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILogoData } from '../../../schemas/apis/interface';

export interface BrandingConfig {
  logo?: string;
  title: string;
  description?: string;
  isCustomized: boolean;
  logoId?: string;
  logoMetadata?: ILogoData;
}

interface BrandingState {
  config: BrandingConfig;
}

const initialState: BrandingState = {
  config: {
    title: 'QuibbleAI',
    description: 'AI Voice Assistant Platform',
    isCustomized: false,
  },
};

const brandingSlice = createSlice({
  name: 'branding',
  initialState,
  reducers: {
    updateBranding: (state, action: PayloadAction<Partial<BrandingConfig>>) => {
      state.config = {
        ...state.config,
        ...action.payload,
        isCustomized: true,
      };
    },
    resetBranding: state => {
      state.config = {
        title: 'QuibbleAI',
        description: 'AI Voice Assistant Platform',
        isCustomized: false,
      };
    },
    setLogo: (state, action: PayloadAction<string>) => {
      state.config.logo = action.payload;
      state.config.isCustomized = true;
    },
    removeLogo: state => {
      state.config.logo = undefined;
      state.config.logoId = undefined;
      state.config.logoMetadata = undefined;
    },
    setLogoFromApi: (state, action: PayloadAction<ILogoData>) => {
      state.config.logo = action.payload.logoUrl;
      state.config.logoId = action.payload._id || action.payload.id;
      state.config.logoMetadata = action.payload;
      state.config.title = action.payload.title;
      state.config.description = action.payload.subtitle;
      state.config.isCustomized = true;
    },
  },
});

export const {
  updateBranding,
  resetBranding,
  setLogo,
  removeLogo,
  setLogoFromApi,
} = brandingSlice.actions;

export default brandingSlice.reducer;
